<template>
  <div :class="'alert '+shown+' '+type">
    <button class="close" v-on:click.prevent="close">&times;</button>
    <p class="alert-title">{{ title }}</p>
    <p class="alert-content" v-html="content"></p>
  </div>
</template>

<script>
import { EventBus } from '../main'

  export default {
    name : "alert",
    props : [
      "shown",
      "title",
      "type",
      "content"
    ],
    methods : {
      close : function(e){
        EventBus.$emit("hideAlert", "hide")
      }
    }
  }
</script>

<style lang="scss">
  .alert {
    position: fixed;
    top: -500px;
    right: 50px;
    transition: top .3s;
    width: 300px;
    background: #fff;
    border: 1px solid #ccc;
    border-top: 10px solid #ccc;
    padding: 10px;
    z-index: 1000;
    border-radius: 3px;
    box-shadow: 1px 1px 2px rgba(0,0,0,.25);
    &.shown {
      top: 50px;
    }
    .close {
      position: absolute;
      border: 0;
      background: transparent;
      right: 5px;
      top: 0px;
      cursor: pointer;
      font-size: 25px;
    }
    .alert-title {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .alert-content {
      font-size: 14px;
      margin-bottom: 0;
    }
    &.success {
      border-top-color: #32b643;
    }
    &.error {
      border-top-color: #e85600;
    }
    &.warning {
      border-top-color: #ffb700;
    }
  }
</style>
